/**
 * Placeholder substitution for panel text.
 *
 * `{taskName}` style tokens are replaced with values from the render context.
 * Substitution produces a STRING that the renderer puts in a text node — there
 * is no HTML path here, by design (see the security posture note in
 * `packages/db-types/src/panel-definition.ts`).
 *
 * An unknown placeholder renders LITERALLY rather than as an empty string. A
 * visible `{taksName}` in the UI is an authoring bug someone will notice and
 * fix; a silent blank is one that ships.
 */

/** Matches `{name}` where name is a simple identifier. */
const PLACEHOLDER_PATTERN = /\{([A-Za-z_][A-Za-z0-9_]*)\}/g;

export function substitutePlaceholders(
  text: string,
  values: Record<string, string | number> | undefined,
): string {
  if (!values) return text;
  return text.replace(PLACEHOLDER_PATTERN, (whole, name: string) => {
    const value = values[name];
    if (value === undefined || value === null) return whole;
    return String(value);
  });
}
